
<p-card>
    <div class="grid">
        <div *ngIf="snps.length > 0" class="col-4">
            <h2>Sample ID: {{snps[0].sampleId}}</h2>
            <h2>Order Date: {{snps[0].orderDate | date:'shortDate'}}</h2>
            <h2>Wellplate: {{snps[0].wellplateName}}</h2>
            <h2>Sample: {{snps[0].sampleName}}</h2>
            <h2>Strain: {{snps[0].strainName}}</h2>
        </div>
        <div class="col-4 mr-5 snp-list">
            <div class="grid">
                <div class="col-5">Probe</div>
                <div class="col-2">Result</div>
                <div class="col-2 mr-2">Reference</div>
            </div>
            <div *ngIf="snps != undefined">
                <div class="grid" *ngFor="let snp of snps" [ngClass]="getSnpClass(snp.result, snp.referenceProbe?.value)">
                    <div class="col-5">{{snp.probeName}}</div>
                    <div class="col-2">{{snp.result}}</div>
                    <div class="col-2 mr-2">{{snp.referenceProbe?.value}}</div>
                </div>
            </div>
        </div>
        <div class="col-3">
            <div class="grid">
                <div class="col-12">
                    <h5>Sample Name</h5>
                    <input type="text" pInputText [(ngModel)]="sampleName" (blur)="SampleNameChange()"/>
                </div>
                <div class="col-12">
                    <h5>Reference</h5>
                    <p-dropdown [options]="references" [(ngModel)]="selectedReference" optionLabel="name" [filter]="true" 
                    filterBy="name" [showClear]="true" placeholder="Select a Reference" (onChange)="referenceChange()">
                        <ng-template pTemplate="selectedItem">
                            <div class="country-item country-item-value" *ngIf="selectedReference">
                                <div>{{selectedReference.name}}</div>
                            </div>
                        </ng-template>
                        <ng-template let-references pTemplate="item">
                            <div class="country-item">
                                <div>{{references.name}}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <div class="col-12">
                    <h5>Location</h5>
                    <p-dropdown [options]="locations" [(ngModel)]="selectedLocation" optionLabel="name" [filter]="true" 
                    filterBy="name" [showClear]="true" placeholder="Select a Location" (onChange)="locationChange()">
                        <ng-template pTemplate="selectedItem">
                            <div *ngIf="selectedLocation">
                                <div>{{selectedLocation.name}}</div>
                            </div>
                        </ng-template>
                        <ng-template let-locations pTemplate="item">
                            <div>
                                <div>{{locations.name}}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <div class="col-12">
                    <h5>Stock</h5>
                    <p-dropdown [options]="stocks" [(ngModel)]="selectedStock" optionLabel="name" [filter]="true" 
                    filterBy="name" [showClear]="true" placeholder="Select a Stock" (onChange)="stockChange()">
                        <ng-template pTemplate="selectedItem">
                            <div *ngIf="selectedStock">
                                <div>{{selectedStock.name}}</div>
                            </div>
                        </ng-template>
                        <ng-template let-stocks pTemplate="item">
                            <div>
                                <div>{{stocks.name}}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <!--<h5>Add Reference</h5>
                <p-fileUpload #fubauto mode="basic" name="references[]" url="./" accept="image/*" (onUpload)="onUpload($event)" [auto]="true" chooseLabel="Browse"></p-fileUpload>-->
            </div>
        </div>
    </div>
</p-card>